document.addEventListener('DOMContentLoaded', function() {
  const intervalId = setInterval(() => {
    const element = document.querySelector('.bold_options');
    const element2 = document.querySelector('.uploadkit.uploadkit-injected');
    if (element && element2) {
      clearInterval(intervalId);
      boldTooltips();
      var productTitle = document.querySelector('.product__title').textContent;
      if (productTitle.includes('Pre-Burned Screen')) {
        if (productTitle.includes('Standard') || productTitle.includes('Large') || productTitle.includes('Extra Large')) {
          var termsOfService = document.querySelector('.bold_option_checkbox:last-child');
          
          var quantity = document.querySelector('.product__block__quantity');
          var uploadField = document.querySelector('.uploadkit.uploadkit-injected');
          var boldOptions = document.querySelector('.bold_option_set');
          var optionFile = document.querySelector('.main-product-cro .bold_option_checkbox:last-child');
          if (optionFile) {
            boldOptions.insertBefore(uploadField, optionFile);
          } else if (boldOptions) {
            boldOptions.insertBefore(uploadField, termsOfService);
          }
          
          var addTOcart = document.querySelector('.main-product-cro .product__submit__buttons product-add-button');
          if (addTOcart) {
          } else {
            boldOptions.insertBefore(quantity, termsOfService);
          }
          uploadField.appendChild(document.querySelector('.required_option_error'));
          uploadField.querySelector('.uploadkit-button').addEventListener('click', function() {
            document.querySelector('.required_option_error').style.display = 'none';
          })
        }
      }
    }
  }, 100);
});

function boldTooltips() {
  var boldOptions = document.querySelectorAll('.bold_options');
  boldOptions.forEach((bold) => {
    bold.addEventListener('mouseover', function(event) {
      var tooltip = event.target.parentElement.parentElement;
      if (event.target.className == 'bold_option_title' && tooltip.querySelector('.bold_help_text img')) {
        console.log(tooltip.querySelector('.bold_help_text img'));
        tooltip.querySelector('.bold_help_text img').classList.toggle('visible_tooltip');
      } else {
        document.querySelectorAll('.bold_help_text img').forEach((img) => {
          img.classList.remove('visible_tooltip');
        })
      }
    });
  })
}
